"use strict";

import SVGPathCommander from "./main.ts";

export * from "./types.ts";
export * from "./interface.ts";

export { SVGPathCommander };
export default SVGPathCommander;
export {};
